import { DomainModel, DomainService, URLParamsModel,DomainPostRequest, GeoService } from "@bt/core";
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from "angular-notifier";
import { Router, ActivatedRoute } from "@angular/router";
import { NgModule } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormsModule,FormArray,AbstractControl, FormControl,ValidatorFn } from "@angular/forms";
import { Component, OnInit, OnDestroy, } from "@angular/core";
import {faSave, faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from "constants";

@Component({
  selector: 'app-newdomain',
  templateUrl: './newdomain.component.html',
  styleUrls: ['./newdomain.component.scss']
})
export class NewdomainComponent extends BaseComponent implements OnInit {
  utmMarkNames: string[]=["utm_source","utm_term","utm_content"];

  //[x: string]: any;

  faSave = faSave;
  faArrowLeft = faArrowLeft;

  domainModel: DomainPostRequest;
  public notificationGeoOptions: any = [];

  private id: string;
  public domainOptions: any = [];
  public domainBlackout: any = [];
  public domainMonetization: any = [];
  public validForm: FormGroup;
  public selectValue: any;
  public config: any;
  public newTokenParamName:string;
  //public reg: any;
  public validateTokenNameFnc: any;
  public utmarray : any = [];
  notifier: any;

  private ctrl: any;
  constructor(
    private router: Router,
    private domainService: DomainService,
    private notifierService: NotifierService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private geoService: GeoService,
    ) {
    super();
    this.notifier = notifierService;
    this.ctrl = this;
  }

  ngOnInit() {
    var t = this;
    function blackoutMsgValidator(control: AbstractControl): { [key: string]: boolean } | null {

      if (!!control.value  && (isNaN(control.value) || control.value.length > 20)) {
        var ar = control.value.split(" ");
        for(var i =0;i<ar.length;i++){
          if(ar[i].length > 20)
            return { 'maxLenBlackoutMsg': true };
        }

      }
      return null;
    }

    this.validForm = this.fb.group({
      textNotification:     ["", [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      linkNotification:     ["", [Validators.required, Validators.maxLength(100), Validators.minLength(3), Validators.pattern(t.linkPattern)]],
      //descNotification:     ["", [Validators.required, Validators.maxLength(100), Validators.minLength(3)]],
      typeNotification:     ["", [Validators.required]],
      geoNotification:     ["", [Validators.required]],
      numbNotification:     [{ disabled: true, value: '' }, [Validators.required, Validators.min(0), Validators.max(999999)]],
      blackoutMsg:     [{ disabled: true, value: '' }, [Validators.required, Validators.minLength(10), Validators.maxLength(70), blackoutMsgValidator]],
      blackoutLiveSec: [{ disabled: true, value: ''}, [Validators.required,Validators.min(0), Validators.max(9999999999), Validators.pattern(t.integerPattern) ]],
      blackoutNotification: ["", [Validators.required]],
      monetizationNotification: ["", [Validators.required]],
      utmMarks :this.fb.array([]),
      tokenParams :this.fb.array([]),
    });

    this.domainModel = new DomainPostRequest();
    this.validateTokenNameFnc =  function ValidateTokenName(control: AbstractControl): {[key: string]: boolean} | null  {
      const creds = t.validForm.controls.tokenParams as FormArray;
      var repeats=0;
      for(var i=0;i< t.utmMarkNames.length;i++)
      {
        var tokenName = control.value.trim();
        if(t.utmMarkNames[i]== tokenName){
          return { 'existUtmName': true };
        }
      }

      for(var i=0;i< creds.getRawValue().length;i++)
      {
        if(creds.getRawValue()[i].value== control.value){
          repeats++;
        }
        if((<any>creds).controls[i].controls.value== control)
        {
          break;
        }
      }
      if(repeats>=2){
        return { 'uniqueInvalid': true };
      }


      return null;
    }

    this.GetGeos();

    this.config = {
      labelField: 'label',
      valueField: 'value',
      searchField: 'label',
      highlight: false,
      create:false,
      persist:true,
      //plugins: ['dropdown_direction', 'remove_button'],
      dropdownDirection: 'down',
      maxItems: 1
    };

    this.domainOptions = [
      { value: 0,  name: "NoEffects",         code: "", label: "Без эффектов" },
      { value: 1,  name: "LoadAfterNSeconds", code: "", label: "Загрузка через N секунд" },
      { value: 2,  name: "JavaScriptCall",    code: "", label: "Вызов через функцию JavaScript" },
    ];

    this.domainBlackout = [
      { value: 0,  name: "NoEffects", code: "", label: "Без эффектов" },
      { value: 1,  name: "BlackOut",  code: "", label: "С затемнением" },
    ]

    this.domainMonetization = [
      { value: 0,  name: "Adsent",   code: "", label: "Отсутствует" },
      { value: 1,  name: "OnlyNews", code: "", label: "Только новостная" },
      { value: 2,  name: "Full",     code: "", label: "Полная" },
    ];

  }
  public elemIsInvalid2(t) {
  }
  public textErrorStr2(t) {
  }

  get textNotification()     { return this.validForm.get('textNotification'); }
  get linkNotification()     { return this.validForm.get('linkNotification'); }
  //get descNotification()     { return this.validForm.get('descNotification'); }
  get typeNotification()     { return this.validForm.get('typeNotification'); }
  get geoNotification()     { return this.validForm.get('geoNotification'); }
  get numbNotification()     { return this.validForm.get('numbNotification'); }
  get blackoutMsg()     { return this.validForm.get('blackoutMsg'); }
  get blackoutLiveSec()     { return this.validForm.get('blackoutLiveSec'); }
  get blackoutNotification() { return this.validForm.get('blackoutNotification'); }
  get monetizationNotification() { return this.validForm.get('monetizationNotification');}
  get utmMarks() { return this.validForm.controls.utmMarks; }
  get tokenParams() { return this.validForm.controls.tokenParams; }

  public tokenParami(i:number) :AbstractControl {
    return (<any>this).tokenParams.controls[i].controls.value;
  }

  isNSelect(){
    if(this.domainModel.type == 1) {
      this.numbNotification.enable();
      return true;
    }else{
      this.domainModel.n = 0;
      this.numbNotification.disable();
      return false;
     }
  }

  GetGeos(){
    this.setLoading(true);
    this.geoService.GetGeos()
    .then((resp) => {
      // this.notificationGeoOptions.push({label:"Все Гео",value: "0"});

      for(let geo of resp.data){
        this.notificationGeoOptions.push({label: geo.name, value: geo.id});
      }
      this.setLoading(false);
      this.getOrCreateDomain();
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении элементов Гео");
    });
  }

  getOrCreateDomain(){
    this.id =  this.route.snapshot.paramMap.get('id');
    if(this.id) this.GetEditDomain(this.id);
      else{
        this.domainModel.type = 0;
        this.domainModel.n = 0;
        this.domainModel.blackout = 0;
        this.domainModel.monetization = 0;
        this.domainModel.isopentokensForUrl = false;
        this.domainModel.isopenuTMForUrl = false;

        const creds = this.validForm.controls.utmMarks as FormArray;

      }
  }

  GetEditDomain(id: string){
    var t = this;
    t.setLoading(true);
    t.domainService.GetEditDomain(id)
    .then((resp) => {
      //получили домен по id
      t.domainModel = resp.data;
      t.domainModel.isopentokensForUrl = t.domainModel.tokensForUrl.length>0;
      t.domainModel.isopenuTMForUrl = t.domainModel.utmForUrl.length>0;
      const contrutmMarks = t.validForm.controls.utmMarks as FormArray;
      const contrtokenParams = t.validForm.controls.tokenParams as FormArray;
      var dict = {};
      // this.domainModel.utmForUrl.forEach(x=>{
      //   dict[x.key]={
      //     key: x.key,
      //     value: x.value,
      //   };
      // });
      if(t.domainModel.isopenuTMForUrl)
      t.domainModel.utmForUrl.forEach(x=>{
        contrutmMarks.push(t.fb.group({
          // key: x.key,
          value:  [x.value],
        }));
      });
      t.domainModel.tokensForUrl.forEach(x=>{
        contrtokenParams.push(t.fb.group({
          // key: x.key,
          value:  [x.value, [Validators.required,t.validateTokenNameFnc, Validators.pattern(t.utmPattern)]],
        }));
      });

      t.setLoading(false);

    })
    .catch((error)=>{

      //не получилось, на фартануло :c
      t.notifier.notify('error', "Редактируемый домен не получен");
      t.setLoading(false);
    });
  }



  CreateDomain(domainModel){
    this.setLoading(true);
    if (!this.validForm.valid) {
      this.setLoading(false);
      this.notifier.notify('error', "Проверьте корректность данных");
      this.markFormGroupTouchedAndDirty(this.validForm);
      return;
    }
    this.domainModel.utmForUrl = this.validForm.controls.utmMarks.value as URLParamsModel[];
    this.domainModel.tokensForUrl = this.validForm.controls.tokenParams.value as URLParamsModel[];
    this.domainService.CreateDomain(domainModel)
    .then((resp) => {
      this.setLoading(false);
      this.router.navigateByUrl('app/domains');
    })
    .catch((responce)=>{
      var text = this.GetErrorMessageText("Не удалось сохранить данные домена", responce);
      this.notifier.notify('error', text);

      this.setLoading(false);
    });
  }

  clickUtmMarks(){
    if(this.domainModel.isopenuTMForUrl)
    {
      while(this.validForm.controls.utmMarks.value.length>0)
      {
        (this.validForm.controls.utmMarks as any).removeAt();
      }
    }
    else{
      const creds = this.validForm.controls.utmMarks as FormArray;
      this.utmMarkNames.forEach(x=>{
        creds.push(this.fb.group({
          // key: x,
          value: x,
        }));
      });
    }
    this.domainModel.isopenuTMForUrl=!this.domainModel.isopenuTMForUrl;
  }

  clickTokenParams(){
    if(this.domainModel.isopentokensForUrl)
    {
      while(this.validForm.controls.tokenParams.value.length>0)
      {
        (this.validForm.controls.tokenParams as any).removeAt();
      }
    }

    this.domainModel.isopentokensForUrl=!this.domainModel.isopentokensForUrl;
  }

  addTokenParam(){
    const creds = this.validForm.controls.tokenParams as FormArray;
    var t = this;
    creds.push(this.fb.group({
      // key: [t.newTokenParamName, [Validators.required]],
      value: ['', [Validators.required,t.validateTokenNameFnc, Validators.pattern(this.utmPattern)]],
    }));
    this.newTokenParamName = null;
  }

  deleteTokenParam(i:number){
    (this.validForm.controls.tokenParams as FormArray).removeAt(i)
  }

  isHasTokenName() : boolean{
    const creds = this.validForm.controls.tokenParams as FormArray;
    for(var i=0;i< creds.getRawValue().length;i++)
    {
      if(creds.value[i].key== this.newTokenParamName){
        return true;
      }
    }
    return false;
  }
  isExistInUTMMarksName() : boolean{
    for(var i=0;i< this.utmMarkNames.length;i++)
    {
      if(this.utmMarkNames[i]== this.newTokenParamName){
        return true;
      }
    }
    return false;
  }


  blackoutChanged(event){
    if(event == "0") {
      this.blackoutMsg.disable();
      this.blackoutLiveSec.disable();
    }
    else{
      this.blackoutMsg.enable();
      this.blackoutLiveSec.enable();
     }
  }

  goBack() {
    this.router.navigateByUrl('app/domains');
  }

}



// WEBPACK FOOTER //
// ./src/app/newdomain/newdomain.component.ts